import { DragHandleRule } from '@tiptap/extension-drag-handle';

/**
 * Re-implementation of the built-in `listItemFirstChild` rule.
 *
 * Excludes the first child of a listItem/taskItem (typically the paragraph)
 * so that the listItem itself becomes the drag target instead.
 */
const listItemFirstChild: DragHandleRule = {
  id: 'listItemFirstChild',
  evaluate: ({ parent, isFirst }) => {
    if (!isFirst) {
      return 0;
    }
    const listItemTypes = ['listItem', 'taskItem'];
    if (parent && listItemTypes.includes(parent.type.name)) {
      return 1000;
    }
    return 0;
  },
};

/**
 * Re-implementation of the built-in `inlineContent` rule.
 *
 * Excludes inline and text nodes from being drag targets.
 */
const inlineContent: DragHandleRule = {
  id: 'inlineContent',
  evaluate: ({ node }) => {
    if (node.isInline || node.isText) {
      return 1000;
    }
    return 0;
  },
};

/**
 * Custom default rules that omit `listWrapperDeprioritize`.
 *
 * The built-in `listWrapperDeprioritize` rule excludes bulletList/orderedList
 * from being drag targets entirely. This prevents the drag handle from
 * appearing when the cursor is over the bullet/number marker (which lives in
 * the <ul>/<ol> padding area).
 *
 * By dropping that rule, the list item still wins when hovering over text
 * (deeper depth wins the tie-break), and a valid target is found when
 * hovering over the marker area.
 */
export const LIST_FRIENDLY_DEFAULT_RULES: DragHandleRule[] = [listItemFirstChild, inlineContent];
